import DateRange from "./DateRange.tsx";
import {APP} from "../../Utils/Constants.ts";
import Sort from "../Sort.tsx";
import useFilterHandlers from "../../Hooks/useFilterHandlers.ts";
import {useContext} from "react";
import {DataPageContext} from "../../Context/DataPageContext.tsx";

const CatalogHeader = () => {

  const { dataPage } = useContext(DataPageContext);

  const { handleFilter, handleFilterArray, getFilterValue } = useFilterHandlers();
  return(
    <div className="catalog-header">
      <div className="catalog-header__filters">
        {dataPage !== "node-page-117" ?
          <DateRange handleDate={handleFilterArray} value={getFilterValue(APP.FILTER.STARTDATE.FIELD)}/> :
          <div></div>
        }
        <Sort
          value={getFilterValue('sort')} handlerOrder={handleFilter} />
      </div>
    </div>
  )
}

export default CatalogHeader;
